// import glo from '../../main'
import { tkParse } from '@moke/vue-tk'
export default {
  className: 'salesVolume',
  title: '销量统计',
  defaultOrder: '-num',
  perPage: 5,
  render: (record) => {
    return record.orderId
  },
  mixin: {
    fields: [
      {
        name: 'shop',
        render: (record) => {
          return record && record.shop && record.shop.name
        }
      },
      {
        name: 'num',
        width: 100
      },
      {
        name: 'money',
        width: 100,
        render: (record) => {
          return record && record.money ? record.money.toFixed(2) : 0
        }
      }
    ]
  },
  hooks: {
    async beforeFetch ({ where }) {
      // where.type = 'shopping'
      // where.deliveryMode = 'pickup'
      // where.state = {
      //   $nin: ['bePaid', 'refund']
      // }
      // 获取停止时间
      var { data: time } = await tkParse.get('/settings/time')
      console.log(time)
      var now = new Date()
      var today = Date.parse(
        new Date(
          `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()} ${time}`
        )
      )
      var yesterday = today - 24 * 60 * 60 * 1000
      var yesterdayIos = new Date(yesterday).toISOString()
      var todayIos = new Date(today).toISOString()
      where.createdAt = {
        $gte: yesterdayIos,
        $lte: todayIos
      }
    }
  }
}
